import { Component, Input, ElementRef, ViewChild, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { onlyNumbers } from '../share-function';

@Component({
  selector: 'app-combo-box',
  templateUrl: './combo-box.component.html',
  styleUrls: ['./combo-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboBoxComponent),
      multi: true
    }
  ]
})
export class ComboBoxComponent implements ControlValueAccessor {

  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() items: string[] = []; // Array of pure strings from your API
  @Input() required: boolean = false;
  @ViewChild('comboBox') comboBox!: ElementRef;
  @Input() isAllowInputyping: boolean = true;
  @Input() isDisabled = false;

  selectedValue: string = '';
  showDropdown = false;
  checkOnlyNumber = onlyNumbers;

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.selectedValue = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  selectItem(item: string) {
    this.selectedValue = item; // item is already the string value
    this.onChange(item);       // Send string back to the parent form
    this.onTouched();
    this.showDropdown = false;
  }

  onInputChange(value: string) {
    this.selectedValue = value;
    this.onChange(value);
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (this.comboBox && !this.comboBox.nativeElement.contains(event.target)) {
      this.showDropdown = false;
      this.onTouched();
    }
  }
}